<template lang="pug">
  .beauty-classes-show
    .beauty-classes(v-if='beautyClass')
      .beauty-class.row
        .col-lg-5
          img(:src='beautyClass.attributes.image')
        .col-lg-7
          .beauty-class-title(v-text='beautyClass.attributes.name')
          loyalty-tiers(:loyaltyTier='beautyClass.attributes["loyalty-tier"]')
          .beauty-class-description.booking-service-description(v-html='beautyClass.attributes.description')
          .terms
            span(v-if='beautyClass.attributes["terms-and-conditions"]' v-text='`${$t("common.termsAndConditions")}:`')
            .beauty-class-terms.booking-service-description(v-html='beautyClass.attributes["terms-and-conditions"]')
          timetrade-button(:text='$t("retailStore.rsvpNow")' v-if='displayTimetrade(beautyClass)' :query='timetradeQuery(beautyClass)' :activity='beautyClass' :loyaltyTiers='beautyClass.attributes["beauty-pass-tier"]' :store='store')
          inhouse-button(:text='$t("retailStore.rsvpNow")' v-if='displayInhouse(beautyClass)' :activity='beautyClass' :loyaltyTiers='beautyClass.attributes["beauty-pass-tier"]')
    .beauty-classes(v-else)
      .beauty-classes-info
        .main-title(v-text='$t("retailStore.classes")')
        .main-description(v-text='$t("bookingService.beautyClassesDescription")')
      .beauty-class.row(v-for='beautyClass in beautyClasses', :key='beautyClass.attributes["slug-url"]')
        .col-lg-5
          img(:src='beautyClass.attributes.image')
        .col-lg-7
          router-link(:to="store ? `${store.attributes['slug-url']}/beauty-classes/${beautyClass.attributes['slug-url']}` : `beauty-classes/${beautyClass.attributes['slug-url']}`")
            .beauty-class-title(v-text='beautyClass.attributes.name')
          loyalty-tiers(:loyaltyTier='beautyClass.attributes["loyalty-tier"]')
          .beauty-class-description.booking-service-description(v-html='beautyClass.attributes.description')
          .terms
            span(v-if='beautyClass.attributes["terms-and-conditions"]' v-text='`${$t("common.termsAndConditions")}:`')
            .beauty-class-terms.booking-service-description(v-html='beautyClass.attributes["terms-and-conditions"]')
          timetrade-button(:text='$t("retailStore.rsvpNow")' v-if='displayTimetrade(beautyClass)' :query='timetradeQuery(beautyClass)' :activity='beautyClass' :loyaltyTiers='beautyClass.attributes["beauty-pass-tier"]' :store='store')
          inhouse-button(:text='$t("retailStore.rsvpNow")' v-if='displayInhouse(beautyClass)' :activity='beautyClass' :loyaltyTiers='beautyClass.attributes["beauty-pass-tier"]')

</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "beautyClassesDescription": "Learning is fun when it’s with Sephora! From skincare basics to makeup trends, let our Beauty Advisors guide you on your beauty journey."
    }
  },
  "lng_zh": {
    "bookingService": {
      "beautyClassesDescription": "Learning is fun when it’s with Sephora! From skincare basics to makeup trends, let our Beauty Advisors guide you on your beauty journey."
    }
  },
  "lng_th": {
    "bookingService": {
      "beautyClassesDescription": "บริการแต่งหน้าโดย Beauty Advisor ผู้เชี่ยวชาญที่จะทำให้คุณสวยในแบบที่คุณต้องการ สามารถขอรับบริการแต่งหน้ารวมถึงเรียนรู้เทคนิคเมกอัพ และทดลองผลิตภัณฑ์ใหม่ ๆ ที่คุณชื่นชอบ"
    }
  },
  "lng_id": {
    "bookingService": {
      "beautyClassesDescription": "Learning is fun when it’s with Sephora! From skincare basics to makeup trends, let our Beauty Advisors guide you on your beauty journey."
    }
  },
  "lng_ko": {
    "bookingService": {
      "beautyClassesDescription": "세포라에서 즐거운 뷰티 클래스를 경험해보세요! 스킨케어 기초부터 메이크업 트렌드까지, 뷰티 어드바이저가 여러분을 아름다움의 여정으로 안내해드립니다. "
    }
  }
}
</i18n>

<script>
import isEmpty from 'lodash/isEmpty'
import { createNamespacedHelpers } from 'vuex'
import TimetradeButton from './timetrade-button.vue'
import InhouseButton from './inhouse-button.vue'
import LoyaltyTiers from './loyalty-tiers.vue'

const { mapGetters } = createNamespacedHelpers('bookingService')

export default {
  name: 'BeautyClasses',
  components: { TimetradeButton, LoyaltyTiers, InhouseButton },
  props: [
    'beautyClasses',
    'store',
    'beautyClass'
  ],
  computed: {
    ...mapGetters(['isBookable', 'hasVacancy', 'objectById'])
  },
  methods: {
    timetradeQuery (beautyClass) {
      return {
        appointmentTypeId: beautyClass.attributes['timetrade-appointment-type-id']
      }
    },
    displayTimetrade (beautyClass) {
      if (beautyClass.attributes['bookable'] === true) {
        return !isEmpty(beautyClass.attributes['timetrade-appointment-type-id'])
      }
      return false
    },
    displayInhouse (beautyClass) {
      if (beautyClass.attributes['bookable'] === true) {
        return isEmpty(beautyClass.attributes['timetrade-appointment-type-id'])
      }
      return false
    }
  }
}
</script>

<style scoped lang='scss'>
  .terms {
    margin-bottom: 10px;
  }

  .beauty-classes-show {
    line-height: 20px;
  }

  .main-description, .beauty-class-description {
    line-height: 18px;
    margin-bottom: 10px;
  }

  .main-title, .beauty-class-title {
    @include font-weight-bold;
    font-size: 16px;
    margin-bottom: 5px;
  }

  .beauty-class {
    padding-top: 10px;
    padding-bottom: 20px;
  }

  .beauty-class + .beauty-class {
    border-top: 1px solid $grey-light;
  }

  img {
    max-width: 100%;
  }

  .enroll-btn {
    display: block;
    max-width: 200px;
  }

  @include media-breakpoint-down(md) {
    .enroll-btn {
      width: 160px;
    }
  }
</style>
